import React,{useState,useEffect} from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import Panel from '../ui/Panel'
import './dashboard.css'

const RING_R = 18
const RING_C = 2 * Math.PI * RING_R

export default function DashboardChallenges() {

    const [data,setData]=useState([])
    const [isLoading,setIsLoading]=useState(true)
    const [chartData,setChartData]=useState([])
    const navigate=useNavigate()


    useEffect(()=>{
        loadData()
    },[])

    const loadData=()=>{
        //setIsLoading(true)
        const obj={
            SportID:sessionStorage.getItem('SportID'),
            Countries:JSON.parse(sessionStorage.getItem('appCountries'))
        }
        axios.post(process.env.REACT_APP_API_SERVER+'manager/dashboard/challenges',obj,{
          headers: {
              'Authorization': 'Bearer '+sessionStorage.getItem("mngapiToken")
              }
          })
        .then(res=>{

            setData(res.data)
            const xdata=[]
            res.data.forEach((item,index)=>{
                const obj={
                    name:item.Title,
                    value:item.CompletedPercentage,
                    index:index+1
                }
                xdata.push(obj)
            })
            setChartData([...xdata])
            setIsLoading(false)
        }).catch(err=>{
            setIsLoading(false)

        })
    }

    const pctOf=(item)=>{
        const raw=Number(item.CompletedPercentage) || 0
        return Math.max(0,Math.min(100,Math.round(raw)))
    }

    const completed=data.filter(item=>pctOf(item)>=100).length

    const subtitle=data.length===0
      ? 'Completion across your challenges'
      : (completed===data.length
          ? `All ${data.length} challenges fully completed`
          : `${completed} of ${data.length} challenges fully completed`)

    const rowBody=(item)=>{
        const pct=pctOf(item)
        const tasks=Number(item.c) || 0

        return(
            <>
                <svg className="ring" viewBox="0 0 42 42" role="img" aria-label={`${pct}% complete`}>
                    <circle className="track" cx="21" cy="21" r={RING_R}/>
                    <circle
                        className="val"
                        cx="21" cy="21" r={RING_R}
                        strokeDasharray={RING_C.toFixed(1)}
                        strokeDashoffset={(RING_C * (1 - pct / 100)).toFixed(1)}
                    />
                    <text x="21" y="21">{pct}</text>
                </svg>

                <div>
                    <div className="chal-title">{item.Title}</div>
                    <div className="chal-meta">{tasks} {tasks===1 ? 'task' : 'tasks'}</div>
                </div>

                <span className="chev" aria-hidden="true">
                    <svg viewBox="0 0 24 24"><path d="M9 6l6 6-6 6"/></svg>
                </span>
            </>
        )
    }

    const dataList=data.map((item,index)=>{
        const key=item.ChallengeUUID || index

        if ((Number(item.c) || 0) > 0){
            return(
                <button
                    className="chal"
                    type="button"
                    key={key}
                    onClick={()=>navigate('/challenges/'+item.ChallengeUUID)}
                >
                    {rowBody(item)}
                </button>
            )
        }

        return(
            <div className="chal" key={key}>
                {rowBody(item)}
            </div>
        )
    })

  return (
    <Panel title="Challenges Progress" subtitle={subtitle}>
        {isLoading &&
          <div className="sk-list">
            <div className="skeleton sk-line"></div>
            <div className="skeleton sk-line"></div>
            <div className="skeleton sk-line short"></div>
          </div>
        }

        {!isLoading && data.length===0 &&
          <div className="empty">No challenges published yet.</div>
        }

        {!isLoading && data.length>0 && <div className="scroll-body h-match">{dataList}</div>}
    </Panel>
  )
}
